import * as React from "react";
const SvgEventSetUpCrew = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 52, height: 52, viewBox: "0 0 52 52", fill: "none", ...props }, "...");
export default SvgEventSetUpCrew;
